module.exports = __webpack_public_path__ + "static/media/sample_compliance.09cbd4ea.csv";